import type { FileContent, FileListing, VelocityVersions } from '@mcpanel/core';
import type { FilesApi } from '../pages/FilesTab';
import { rawRequest, uploadRequest } from './client';
import type { VelocityView, ModChange, ModResolveResult, BedrockSettings } from '@mcpanel/core';
export const velocityApi = {
  get: () => rawRequest<VelocityView>('GET', '/velocity'),
  logs: (lines: number) => rawRequest<{ lines: string[] }>('GET', '/velocity/logs?lines=' + lines),
  preview: (change: ModChange) =>
    rawRequest<Omit<ModResolveResult, 'installed'> & { previewHash: string }>(
      'POST',
      '/velocity/plugins/preview',
      change,
    ),
  plugins: (change: ModChange, previewHash: string) =>
    rawRequest('POST', '/velocity/plugins', { ...change, previewHash }),
  start: () => rawRequest('POST', '/velocity/start'),
  stop: () => rawRequest('POST', '/velocity/stop'),
  versions: (version?: string) =>
    rawRequest<VelocityVersions>(
      'GET',
      '/velocity/versions' + (version ? '?version=' + encodeURIComponent(version) : ''),
    ),
  version: (version: string, build: number) => rawRequest('POST', '/velocity/version', { version, build }),
  restart: () => rawRequest('POST', '/velocity/restart'),
  bedrock: (settings: BedrockSettings) => rawRequest('POST', '/velocity/bedrock', settings),
};

export const velocityFilesApi: FilesApi = {
  fileRoots: async () => [],
  listFiles: (_id, path) => rawRequest<FileListing>('GET', '/velocity/files?path=' + encodeURIComponent(path)),
  readFile: (_id, path) => rawRequest<FileContent>('GET', '/velocity/files/content?path=' + encodeURIComponent(path)),
  writeFile: (_id, path, content, expectedSha256) =>
    rawRequest('PUT', '/velocity/files/content', { path, content, expectedSha256 }),
  makeDirectory: (_id, path) => rawRequest('POST', '/velocity/files/mkdir', { path }),
  trashFile: (_id, path) => rawRequest('POST', '/velocity/files/trash', { path }),
  uploadFile: (_id, path, file, overwrite = false) =>
    uploadRequest(`/velocity/files/upload?path=${encodeURIComponent(path)}&overwrite=${overwrite}`, file),
};
